import { Company as CurrentCompany } from '@recruitee/company-types';
import { OfferFull } from '@recruitee/offers-types';

export type GfeaIntegration = {
  id: number;
  roles: {};
  partnerNumber: string;
  customerNumber: string;
  supplierId: string;
};

export type Offer = Pick<
  OfferFull,
  | 'id'
  | 'slug'
  | 'kind'
  | 'status'
  | 'title'
  | 'countryCode'
  | 'stateCode'
  | 'stateName'
  | 'city'
  | 'postalCode'
  | 'description'
  | 'requirements'
  | 'employmentType'
  | 'street'
  | 'careersUrl'
>;

export type Company = Pick<
  CurrentCompany,
  'id' | 'name' | 'street' | 'number' | 'city' | 'postalCode' | 'stateCode' | 'countryCode'
> & { stateName: string | null };

export type Posting = {
  id: number;
  createdAt: string;
  data: PostingData;
  status: PostingStatus;
  duplicateOfferIds: number[];
};

export enum PostingStatus {
  PENDING = 'pending',
  PUBLISHED = 'published',
  REJECTED = 'rejected',
}

export type CreatePostingForm = {
  offerId: number;
  duplicateOfferIds: number[];
  data: PostingData;
};

export type EditPostingForm = {
  duplicateOfferIds: number[];
  data: PostingData;
};

export enum ProfessionCategory {
  WORK = 'work',
  EDUCATION = 'education',
  STUDIES = 'studies',
  TRAINING_INTEGRATED = 'training_integrated',
}

export enum ProfessionType {
  TRAINING = 'a',
  JOB = 't',
}

export type Profession = {
  id: number;
  name: string;
  type: ProfessionType;
  remoteId: string;
};

export type PostingData = {
  companyData: {
    name: string;
    contact: {
      adminId: number | null;
      address: Location;
    };
  };
  offerData: {
    title: string;
    titleCode: string | null;
    titleCodeName: string | null;
    description: string;
    offerType: string;
    socialInsurance: string | null;
    miniJob: string | null;
    supervisionDesired: string | null;
    internetReference: string;
    workingPlan: string;
    numberToFill: number;
    positionLocation: Location;
    positionLocations: PositionLocationGroup[];
    educationType: string | null;
    degreeType: string | null;
    course: string | null;
    courseName: string | null;
    privatePlacement: string | null;
    labourLeasing: string | null;
  };
};

export type PositionLocationGroup = {
  offerIds: number[];
  location: Location;
};

export type Location = {
  countryCode: string;
  postalCode: string | null;
  region: string | null;
  municipality: string | null;
  streetName: string | null;
};

export type Address = {
  postalCode: string;
  region: string;
  city: string;
};

export enum WorkingPlanType {
  REGULAR,
  EDUCATION,
}
